import { ItemTypeConsts } from 'client/util/Constants';
import { featureFlags } from 'client/store/modules/FeatureFlagsModule';

const CommandTemplateAsidePanel = () => import('client/Commands/CommandTemplateAsidePanel.vue');
const CommandTemplateManageEdit = () => import('client/Commands/CommandTemplateDetails/CommandTemplateManageEdit.vue');
const CommandTemplateManageMainPanel = () => import('client/Commands/CommandTemplateManageMainPanel.vue');
const CommandsResultsMainPanel = () => import('client/Commands/CommandsResultsMainPanel.vue');

const commandsProps = {
  templateAsidePanel: {
    isExpanded: true,
    itemType: ItemTypeConsts.commandTemplateWindows,
  },
  templateMainPanel: {
    gettingStartedPanelItemType: ItemTypeConsts.command,
    isAsideOpen: false,
    itemType: ItemTypeConsts.commandTemplateWindows,
    selectedModelId: '',
    setSelectedModelId(selectedModelId) {
      this.selectedModelId = selectedModelId;
    },
  },
};

const metaData = {
  title: 'Commands',
};

export default (enabledFlags) => [
  {
    path: '/commands/newfromtemplate',
    meta: metaData,
    components: {
      asidePanel: CommandTemplateAsidePanel,
      mainPanel: CommandsResultsMainPanel,
    },
    props: {
      mainPanel: commandsProps.templateMainPanel,
      asidePanel: commandsProps.templateAsidePanel,
    },
  },
  {
    path: '/commands/managetemplates',
    meta: metaData,
    components: {
      mainPanel: CommandTemplateManageMainPanel,
    },
    beforeEnter: (to, from, next) => {
      const showRoute = !!enabledFlags[featureFlags.commandTemplateEdit];
      const routeOrRedirect = showRoute ? true : { path: '/commands' };
      next(routeOrRedirect);
    },
    props: {
      mainPanel: {
        ...commandsProps.mainPanel,
        activeTab: 'managetemplates',
      },
    },
  },
  {
    path: '/commands/managetemplates/:id/details',
    meta: metaData,
    components: {
      mainPanel: CommandTemplateManageEdit,
    },
    beforeEnter: (to, from, next) => {
      const showRoute = !!enabledFlags[featureFlags.commandTemplateEdit];
      const routeOrRedirect = showRoute ? true : { path: '/commands' };
      next(routeOrRedirect);
    },
    props: {
      mainPanel: CommandTemplateManageMainPanel,
    },
  },
];
